import type { RyftAccountBalanceGetResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useRyftManagementLedgerBalance = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.RyftManagementLedgerBalance,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "ryft-management/accounts/balance",
      }).then(
        (response) =>
          apiV2AssertResponse<RyftAccountBalanceGetResponseType>(response).data,
      ),
    ...getDefaultQueryOptionsV2<RyftAccountBalanceGetResponseType>({
      context: { scope: "supplier", user, business },
    }),
  });
};
